import { IUploadedImage } from 'libs/hooks/io/useUploadImage';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';
import { EToastType } from 'libs/types/site/IClient';
import {
    EUploadResolution,
    isWithinSize,
    prepareImage
} from 'libs/utils/logic/operations/fileOperations';
import { userMessage } from 'libs/utils/logic/ui/uiLogic';
import { useContext, useRef, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { apiUploadFile } from 'static/api/directApi';

export const useImageUploader = (
    resolutions: EUploadResolution[],
    onFinished: (uploaded: IUploadedImage[], lat: number, lng: number, zoom: number) => void
) => {
    const ctxEdit = useContext(CtxEdit);
    const [, setRerender] = useState<string>('');
    const refProgress = useRef<number>(0);
    const uploaded = useRef<IUploadedImage[]>([]);
    const worldMapLocalStorage = useWorldMapLocalStorage();

    const temporaryToken = worldMapLocalStorage.getTokenForMapId(ctxEdit.map.worldMapId);

    function uploadFiles(selectorFiles: FileList, lat: number, lng: number, zoom: number) {
        console.log('Call uploadFiles', selectorFiles);
        if (selectorFiles) {
            const files = Array.from(selectorFiles);
            refProgress.current += files.length;
            files.forEach((file) => {
                if (!isWithinSize(file.size, 25)) {
                    userMessage(EToastType.ERROR, 'File too large');
                    refProgress.current -= 1;
                } else {
                    const formData = prepareImage(file, resolutions, null, temporaryToken);
                    apiUploadFile(formData)
                        .then((r) => {
                            uploaded.current = [
                                ...uploaded.current,
                                r as unknown as IUploadedImage
                            ];
                            refProgress.current -= 1;
                            if (refProgress.current === 0) {
                                onFinished(uploaded.current, lat, lng, zoom);
                                uploaded.current = [];
                            }
                            setRerender(Math.random().toString());
                        })
                        .catch(() => {
                            userMessage(EToastType.ERROR, 'Upload failed');
                            refProgress.current -= 1;
                            setRerender(Math.random().toString());
                        });
                }
            });
        }
    }

    return { uploadFiles, inProgress: refProgress.current };
};
